(() => {
  const STORAGE_KEY = "1099-engraving-proof-result";

  const setButtonLabel = (button, label) => {
    if (!button || !label) return;
    if (button.tagName === "INPUT") {
      button.value = label;
      return;
    }
    const textNode = button.querySelector("span") || button;
    textNode.textContent = label;
  };

  const addAnotherOrderButton = (root, statusEl) => {
    if (!statusEl || root.querySelector("[data-start-another-engraving]")) return;

    const anotherButton = document.createElement("button");
    anotherButton.type = "button";
    anotherButton.className = "button button--secondary";
    anotherButton.dataset.startAnotherEngraving = "1";
    anotherButton.textContent = "Start Another Engraving Order";
    anotherButton.style.width = "100%";
    anotherButton.style.marginTop = "0.75rem";
    anotherButton.addEventListener("click", () => window.location.reload());

    statusEl.insertAdjacentElement("afterend", anotherButton);
  };

  const initRoot = (root, storedResult) => {
    const nameInput = root.querySelector("[data-proof-name]");
    const emailInput = root.querySelector("[data-proof-email]");
    const nameRequired = nameInput?.closest(".engraving-personalization__field")?.querySelector("small");
    const emailRequired = emailInput?.closest(".engraving-personalization__field")?.querySelector("small");
    nameRequired?.classList.add("engraving-personalization__required");
    emailRequired?.classList.add("engraving-personalization__required");

    if (!storedResult) return;

    const statusEl = root.querySelector("[data-engraving-status]");
    const errorEl = root.querySelector("[data-engraving-error]");

    if (storedResult.state === "error") {
      if (errorEl) {
        errorEl.textContent = String(storedResult.message || "We couldn’t submit your engraving proof request. Please try again.");
        errorEl.hidden = false;
        window.setTimeout(() => errorEl.scrollIntoView({ behavior: "smooth", block: "center" }), 50);
      }
      return;
    }

    if (storedResult.state !== "submitted") return;

    const sectionId = root.dataset.sectionId || "";
    const section = root.closest(".shopify-section")
      || document.getElementById(`shopify-section-${sectionId}`)
      || root.parentElement;
    const form = document.getElementById(`product-form-${sectionId}`)
      || Array.from(section?.querySelectorAll('form[action*="/cart/add"]') || [])
        .find((candidate) => candidate.querySelector('[name="add"]'))
      || null;
    const button = form?.querySelector('[name="add"]')
      || form?.querySelector('button[type="submit"], input[type="submit"]')
      || null;

    const proofRef = String(storedResult.proofRef || "").trim();
    const email = String(storedResult.email || "").trim();
    const referenceText = proofRef ? ` Reference: ${proofRef}.` : "";
    const emailText = email
      ? ` We’ll email your digital proof to ${email}.`
      : " We’ll email your digital proof to the email address you provided.";

    root.dataset.engravingSubmitted = "1";

    if (statusEl) {
      statusEl.textContent = `Proof request received!${referenceText}${emailText} No payment is due yet. Review and approve the proof; once approved, we’ll send your invoice. Production begins after proof approval and payment.`;
      statusEl.classList.add("engraving-personalization__status--success");
      addAnotherOrderButton(root, statusEl);
      window.setTimeout(() => statusEl.scrollIntoView({ behavior: "smooth", block: "center" }), 50);
    }

    if (button) {
      button.disabled = true;
      setButtonLabel(button, "Submitted for Proof");
    }
  };

  const init = () => {
    let storedResult = null;
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        storedResult = JSON.parse(raw);
        window.sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      storedResult = null;
    }

    const roots = Array.from(document.querySelectorAll("[data-engraving-personalization]"));
    roots.forEach((root, index) => initRoot(root, index === 0 ? storedResult : null));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
